<template>
  <div>
    <b-modal
      id="thanks-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
    >
      <div class="header">
        <span class="close-icon" @click="$bvModal.hide('thanks-modal')">
          <img src="@/assets/svg/close.svg" aria-label="close" />
        </span>

        <h3>
          {{ thanksTitle ? thanksTitle : "Спасибо за Ваше обращение!" }} <br />
        </h3>

        <div class="text">{{ thanksText }}</div>
      </div>

      <b-button
        class="button button-gold"
        @click="$bvModal.hide('thanks-modal')"
        >Закрыть</b-button
      >
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["thanksText", "thanksTitle"],

  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  .close-icon {
    float: right;
    cursor: pointer;
    transition: 0.4s all;
    margin-right: 5px;

    &:hover {
      opacity: 0.85;
    }
  }

  h3 {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 20px;
    font-weight: 800;
    font-family: $regular;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
  }
}

.text {
  font-size: 18px;
  text-align: left;
  font-family: $regular;
  margin-bottom: 40px;
  margin-top: 30px;
  color: white;
}

.button {
  width: 100%;
}
</style>
